import { useEffect, useState } from "react";

const NAV_LINKS = [
  { id: "hot", label: "今日热搜" },
  { id: "features", label: "焦点大瓜" },
  { id: "channels", label: "栏目分类" },
  { id: "talk", label: "网友热议" },
  { id: "mood", label: "群众态度" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于本站" },
];

export function Logo() {
  return (
    <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-heading text-lg leading-none text-background-50">
        瓜
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-heading text-xl text-foreground-900">本月大瓜</span>
        <span className="mt-0.5 text-[11px] tracking-wide text-foreground-600">全网热点 · 一网吃尽</span>
      </span>
    </a>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? "border-b border-background-200/70 bg-background-50/90 backdrop-blur" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-[1200px] items-center justify-between px-4 md:px-6">
        <Logo />

        <div className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              className="rounded-full px-3.5 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#submit"
            className="hidden whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 sm:inline-flex"
          >
            投稿线索
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="切换导航菜单"
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-[22px]`} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 backdrop-blur lg:hidden">
          <div className="mx-auto grid w-full max-w-[1200px] gap-1 px-4 py-3 md:px-6">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100 hover:text-primary-700"
              >
                {l.label}
                <i className="ri-arrow-right-s-line text-foreground-400" />
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-1 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              投稿线索
            </a>
          </div>
        </div>
      )}
    </header>
  );
}